
export function actionStr(lang, action) {
    if (lang.tag === 1) {
        switch (action.tag) {
            case 1:
                return "Update";
            case 2:
                return "Delete";
            default:
                return "Create";
        }
    }
    else {
        switch (action.tag) {
            case 1:
                return "Oppdater";
            case 2:
                return "Slett";
            default:
                return "Opprett";
        }
    }
}

